import { API_HOST } from '../../utils/api';
export default function BrandPreview({ profile, onClose }) {
  const colors = profile.brandColors || { primary: '#2563eb', secondary: '#1e40af', accent: '#f59e0b' };
  const fonts = profile.brandFonts || { heading: 'Inter', body: 'Open Sans' };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4" onClick={onClose}>
      <div className="bg-white rounded-2xl shadow-2xl max-w-lg w-full overflow-hidden" onClick={e => e.stopPropagation()}>
        <div className="p-6 border-b border-gray-200 flex justify-between items-center">
          <h2 className="text-lg font-semibold">Brand Preview</h2>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-600 text-2xl">&times;</button>
        </div>

        <div className="p-8">
          {/* Preview card */}
          <div className="rounded-xl overflow-hidden shadow-lg border border-gray-100">
            {/* Header with logo */}
            <div style={{ backgroundColor: colors.primary }} className="p-6 flex items-center gap-4">
              {profile.logoPath ? (
                <img src={`${API_HOST}/${profile.logoPath}`} alt="Logo" className="h-10 max-w-[120px] object-contain bg-white rounded px-2 py-1" />
              ) : (
                <div className="h-10 w-20 bg-white/20 rounded flex items-center justify-center text-white text-xs">Logo</div>
              )}
              <div className="text-white">
                <div style={{ fontFamily: fonts.heading }} className="font-bold text-lg">{profile.companyName || 'Your Company'}</div>
                {profile.tagline && <div className="text-sm opacity-80">{profile.tagline}</div>}
              </div>
            </div>

            {/* Content area */}
            <div className="p-6" style={{ backgroundColor: colors.secondary + '10' }}>
              <h3 style={{ fontFamily: fonts.heading, color: colors.primary }} className="text-xl font-bold mb-3">
                Transform Your Business with Cloud Desktops
              </h3>
              <p style={{ fontFamily: fonts.body }} className="text-gray-600 mb-4 leading-relaxed">
                Discover how modern cloud desktop solutions can streamline your operations, enhance security, and reduce IT costs.
              </p>
              <button
                style={{ backgroundColor: colors.accent }}
                className="px-6 py-2.5 rounded-lg text-white font-medium hover:opacity-90 transition-opacity"
              >
                Learn More
              </button>
            </div>
          </div>

          {/* Color swatches */}
          <div className="mt-6 flex gap-4 justify-center">
            {Object.entries(colors).map(([key, val]) => (
              <div key={key} className="text-center">
                <div className="w-10 h-10 rounded-full border-2 border-gray-200 mx-auto" style={{ backgroundColor: val }} />
                <div className="text-xs text-gray-500 mt-1 capitalize">{key}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
